import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ScoreboardTableComponent from './ScoreboardTableComponent';
import { Col, Card, Row, Button, ButtonGroup, ButtonToolbar } from 'react-bootstrap';

const ScoreboardComponent = (props) => {
    const [loadingData, setLoadingData] = useState(true);
    const [district, setDistrict] = useState("");
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [activeButton, setActiveButton] = useState("");

    useEffect(() => {
        const fetch = async () => {
            try {
                const response = await axios.get('/api/score');
                if (response.status === 200) {
                    setData(response.data);
                }
            } catch (error) {
                console.error('Error:', error);
            } finally {
                setLoadingData(false);
            }
        };
        fetch();
    }, []);

    const handleFilter = (district) => {
        setDistrict(district);
        setActiveButton(district);
        setFilteredData(data.filter(item => item.district === district));
    };

    return (
        <>
            <Col sm={12} md={12} lg={3} className="my-2 mx-auto" id="scoreboard">
                <ButtonToolbar className="m-1">
                    <ButtonGroup>
                        <Button variant={activeButton === "BEK" ? "success" : "secondary"} className="me-1" onClick={() => handleFilter("BEK")}>BEK</Button>
                    </ButtonGroup>
                </ButtonToolbar>
                <ButtonToolbar className="m-1">
                    <ButtonGroup>
                        <Button variant={activeButton === "BEY1" ? "success" : "secondary"} className="me-1" onClick={() => handleFilter("BEY1")}>BEY1</Button>
                        <Button variant={activeButton === "BEY2" ? "success" : "secondary"} className="me-1" onClick={() => handleFilter("BEY2")}>BEY2</Button>
                    </ButtonGroup>
                </ButtonToolbar>
                <ButtonToolbar className="m-1">
                    <ButtonGroup>
                        <Button variant={activeButton === "LS" ? "success" : "secondary"} className="me-1" onClick={() => handleFilter("LS")}>LS</Button>
                    </ButtonGroup>
                </ButtonToolbar>
                <ButtonToolbar className="m-1">
                    <ButtonGroup>
                        <Button variant={activeButton === "LN1" ? "success" : "secondary"} className="me-1" onClick={() => handleFilter("LN1")}>LN1</Button>
                        <Button variant={activeButton === "LN2" ? "success" : "secondary"} className="me-1" onClick={() => handleFilter("LN2")}>LN2</Button>
                        <Button variant={activeButton === "LN3" ? "success" : "secondary"} className="me-1" onClick={() => handleFilter("LN3")}>LN3</Button>
                    </ButtonGroup>
                </ButtonToolbar>
                <ButtonToolbar className="m-1">
                    <ButtonGroup className="d-flex flex-wrap">
                        <Button variant={activeButton === "ML1" ? "success" : "secondary"} className="me-1" onClick={() => handleFilter("ML1")}>ML1</Button>
                        <Button variant={activeButton === "ML2" ? "success" : "secondary"} className="me-1" onClick={() => handleFilter("ML2")}>ML2</Button>
                        <Button variant={activeButton === "ML3" ? "success" : "secondary"} className="me-1" onClick={() => handleFilter("ML3")}>ML3</Button>
                        <Button variant={activeButton === "ML4" ? "success" : "secondary"} className="me-1" onClick={() => handleFilter("ML4")}>ML4</Button>
                        <Button variant={activeButton === "ML5" ? "success" : "secondary"} className="me-1" onClick={() => handleFilter("ML5")}>ML5</Button>
                        <Button variant={activeButton === "ML6" ? "success" : "secondary"} className="me-1" onClick={() => handleFilter("ML6")}>ML6</Button>
                        <Button variant={activeButton === "ML7" ? "success" : "secondary"} className="me-1" onClick={() => handleFilter("ML7")}>ML7</Button>
                        <Button variant={activeButton === "ML8" ? "success" : "secondary"} className="me-1" onClick={() => handleFilter("ML8")}>ML8</Button>
                    </ButtonGroup>
                </ButtonToolbar>
            </Col>
            <Row className='pt-4'>
            </Row>
            <Row>
                <Col className="my-2 mx-auto">
                    <Card>
                        <Card.Body>
                            <div className="card-title text-center h3" style={{ "font-family": "Georgia" }}>{"District - " + district}</div>
                        </Card.Body>
                        <Card.Body style={{ "overflow-x": "auto" }}>
                            {loadingData ? (
                                <p>Loading Please wait...</p>
                            ) : (
                                <ScoreboardTableComponent data={filteredData} pageSize={10} pageCount={filteredData.length / 10} />
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default ScoreboardComponent;